/**
 * The edit api client.
 */
export class EditApi {
    constructor(settings) {
        this.url = settings.url;
    }
    /**
     * Creates a new branch from the given snapshot commit.
     * @param options The options.
     * @returns The branch details.
     */
    async createBranch(options) {
        const url = `${this.url}branch`;
        const body = JSON.stringify({
            SnapshotCommitId: options.snapshotCommitId,
            ExtentPolygon: options.extentPolygon
        });
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        const json = await response.json();
        return json;
    }
    /**
     * Copies a branch from an existing branch.
     * @param options The options.
     * @returns The branch details.
     */
    async copyBranch(options) {
        const url = `${this.url}branch`;
        const body = JSON.stringify({
            branchId: options.branchId
        });
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        const json = await response.json();
        return json;
    }
    /**
     * Gets the latest snapshot commits for each snapshot/
     * @param options
     * @returns
     */
    async getLatestSnapshotCommits(options) {
        const url = `${this.url}snapshot/commit/latest`;
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + options.accessToken,
            },
        });
        const json = await response.json();
        return json.commits;
    }
}
